import type { Address } from 'viem/accounts';
import { z } from 'zod/v4';

import { evmChainIdSchema } from './connect';

export const infinexUserDataSchema = z
  .object({
    username: z.string(),
    chainId: evmChainIdSchema.or(z.string()),
    evmWalletAddress: z.custom<Address>(),
    solanaWalletAddress: z.string(),
    referralCode: z.string(),
  })
  .strict();

const balancesSchema = z
  .object({
    raw: z.string(),
    formatted: z.string(),
  })
  .strict();
export const infinexUserBalancesSchema = z
  .object({
    chainBalanceNative: balancesSchema.describe(
      'Native balance for the current "active" chain.'
    ),
    totalBalanceUsd: balancesSchema.describe(
      "Total balance in USD of the user's wallets across all chains."
    ),
  })
  .strict();

export type InfinexUserData = z.infer<typeof infinexUserDataSchema>;
export type InfinexUserBalances = z.infer<typeof infinexUserBalancesSchema>;
